var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldenBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mingcute:building-2-line",
    clipPath: "url(#clip0_1925_36164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68342 2.05119C8.82671 2.00349 8.97894 1.98887 9.12869 2.00841C9.27844 2.02796 9.42182 2.08117 9.54806 2.16405C9.67431 2.24693 9.78014 2.35733 9.85762 2.48696C9.9351 2.61658 9.98221 2.76208 9.99542 2.91252L9.99942 3.00052V6.65785L12.5288 7.16452C12.7395 7.20652 12.9312 7.31532 13.0753 7.47479C13.2194 7.63426 13.3083 7.83591 13.3288 8.04985L13.3328 8.14452V13.2045H13.9994C14.1693 13.2047 14.3328 13.2698 14.4563 13.3864C14.5799 13.5031 14.6542 13.6625 14.6642 13.8321C14.6742 14.0017 14.619 14.1688 14.5099 14.2991C14.4009 14.4294 14.2462 14.5131 14.0774 14.5332L13.9994 14.5379H1.99942C1.8295 14.5377 1.66607 14.4726 1.54251 14.356C1.41895 14.2393 1.3446 14.0799 1.33464 13.9103C1.32468 13.7406 1.37987 13.5736 1.48893 13.4433C1.59799 13.313 1.75269 13.2293 1.92142 13.2092L1.99942 13.2045H2.66609V4.77785C2.66609 4.37785 2.90342 4.02052 3.26476 3.86185L3.35009 3.82919L8.68342 2.05119ZM8.66609 3.46319L3.99942 5.01852V13.2045H8.66609V3.46319ZM9.99942 8.01852V13.2045H11.9994V8.41785L9.99942 8.01852Z",
    fill: "#D39E36"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1925_36164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenBuilding);
export default __webpack_public_path__ + "static/media/golden_building.06cee429587cca4a21509ef4a53252b9.svg";
export { ForwardRef as ReactComponent };